// extracted by mini-css-extract-plugin
module.exports = {"form":"form_form__3Muto"};